import { BlockItem } from './blocked.item';
import { BlockTree } from './blocked.tree';
import { BlockElement } from './blocked.element';
import { GQueovalDik, QueovalBase, QueovalDik } from '../global';
import { BObjectModel, PropertyData } from '../bodisplay';
import { ParamsMedia } from '../media';

export class MainblockModel extends QueovalBase {
  public IdBO: string;
  public BlockData: BlockItem;
  public SelectedItem: BlockTree;
  public ExploAction: string;
  public ActionResult: string;
  public ReloadedList: Array<BlockTree>;
  public BlockInfo: string;
  public SelectedOfficesList: Array<BlockTree>;
  public SelectedUsersList: Array<BlockTree>;
  public UpdatedAgendasList: Array<BlockElement>;
  public UpdatedPlanningList: Array<QueovalDik>;
  public EntriesPointsList: Array<QueovalDik>;
  public GedDatasList: BlockGedModel;
  public ModelsNames: Array<string>;
  public ModelName: string;
  public Deleted: boolean;
  public UsersSelected: string;
}

export class BlockGedModel {
  public TitreDossier: string;
  public AccessKey: PropertyData;
  public Documents: Array<BlockGedMedia>;
}
export class BlockGedMedia extends ParamsMedia {
  public Model: BObjectModel;
}
